import React from 'react'

import { Badge } from '../'
import * as colors from '../../assets/js/colors'

function BadgeStatusPallet({ status }) {
  switch (status) {
    case 'Tag Não Emitido':
      return <Badge color={colors.gray}>{status}</Badge>
    case 'Tag Emitido':
      return <Badge color={colors.azul}>{status}</Badge>
    case 'Alocado':
      return <Badge color={colors.verde}>{status}</Badge>
    case 'Carregado':
      return <Badge color={colors.pink}>{status}</Badge>
    case 'Carregado Parcialmente':
      return <Badge color={colors.laranja}>{status}</Badge>
    case 'Excluído':
      return <Badge color={colors.vinho}>{status}</Badge>
    default:
      return status ? <Badge color={colors.gray}>{status}</Badge> : null
  }
}

export default BadgeStatusPallet
